import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useLoggedIn } from '#/contexts/UserEnvironmentContext';
import { onClientHydrated } from '#/rendering/state/renderingState';
import {
  incrementPageVisitCount,
  resetPageVisitCount,
} from '#/zustand-stores/pageVisitStore';

// Persist between unmounts
let lastPathname = '';

export function PageVisitCounterGlobalHandler() {
  const location = useLocation();

  const { loggedIn } = useLoggedIn();

  useEffect(() => {
    onClientHydrated(() => {
      if (loggedIn) {
        resetPageVisitCount();
        return;
      }

      if (lastPathname !== location.pathname) {
        incrementPageVisitCount();
        lastPathname = location.pathname;
      }
    });
  }, [location.pathname, loggedIn]);

  return null;
}
